import React, { createContext, FC, ReactNode } from 'react';
import { LoginDTO } from '../types/dtos/auth';

interface DoisFatoresContextValue {
  username: string;
  password: string;
  user: LoginDTO | null;
  setUsername: (username: string) => void;
  setPassword: (password: string) => void;
  setUser: (user: LoginDTO | null) => void;
}

export const DoisFatoresContext = createContext<DoisFatoresContextValue>({
  username: '',
  password: '',
  user: {
    Codigo: '',
    CpfCnpj: '',
    Email: '',
    Empresa: '',
    LoginUsuario: '',
    NomeEmpresa: '',
    NomeUsuario: '',
  },
  setUsername: () => {},
  setPassword: () => {},
  setUser: () => {},
});

interface DoisFatoresProviderProps {
  value: DoisFatoresContextValue;
  children: ReactNode;
}

export const DoisFatoresProvider: FC<DoisFatoresProviderProps> = ({
  value,
  children,
}) => {
  return (
    <DoisFatoresContext.Provider value={value}>
      {children}
    </DoisFatoresContext.Provider>
  );
};
